<template>
  <ValidationObserver ref="formUser">
    <div class="row mt-2">
      <div class="col-md-5">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <dt-input v-model="firstName" name="firstName" label="First Name" validate="required" tabindex="1" @keyup="changed" />
              <dt-input
                v-model="username"
                name="username"
                autocomplete="new-password"
                label="Username (email address)"
                validate="required"
                tabindex="3"
                v-if="isAdding"
                @blur="verifyUser"
                @keyup="changed"
              />
              <div class="mb-4 custom-username" v-else>
                <label class="mr-2">Username:</label>
                <input v-if="editingUsername" v-model="newUsername" />
                <span v-else>{{ username }}</span>
                <a href="#" @click="editUsername" v-show="!editingUsername">
                  <i class="fas fa-pencil-alt"></i>
                </a>
                <a href="#" @click="saveUsername" v-show="editingUsername">
                  <i class="fas fa-save"></i>
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <dt-input v-model="lastName" name="lastName" label="Last Name" validate="required" tabindex="2" @keyup="changed" />
              <dt-select
                v-model="contactType"
                name="contactType"
                label="Contact Type"
                :options="lookups['UserContactType']"
                validate="required"
                tabindex="4"
                v-show="cameFrom > 0"
                @changed="changed"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="cameFrom === 1">
          <div class="row mt-2">
            <div class="form-group col-md-6">
              <dt-select
                v-model="timezone"
                label="Time Zone"
                name="timezone"
                :options="lookups['TimeZone']"
                validate="required"
                tabindex="5"
                @changed="changed"
              />
            </div>
            <div class="form-group col-md-6">
              <dt-select
                v-model="language"
                label="Language"
                name="language"
                :options="lookups['Language']"
                validate="required"
                tabindex="6"
                @changed="changed"
              />
            </div>
          </div>
          <div class="row mt-2" v-if="isAdding">
            <div class="form-group col-md-6">
              <dt-input
                type="password"
                v-model="password"
                autocomplete="new-password"
                name="password"
                label="Password"
                validate="required"
                @blur="verifyPassword"
                tabindex="7"
                @keyup="changed"
              />
            </div>
            <div class="form-group col-md-6">
              <dt-input
                type="password"
                v-model="newpassword"
                autocomplete="new-password"
                name="newpassword"
                label="Password (again)"
                validate="required"
                @blur="verifyPassword"
                @keyup="changed"
                tabindex="8"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <dt-select v-model="role" name="role" label="User Role" :options="roles" validate="required" tabindex="9" @changed="changed" />
            </div>
            <div class="form-group col-md-6">
              <dt-input
                v-model="laborRate"
                name="laborRate"
                label="Labor Rate (per hr)"
                type="number"
                validate="required"
                tabindex="10"
                @keyup="changed"
                @changed="changed"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 pl-4">
              <input type="checkbox" v-model="isInactive" class="custom-checkbox" tabindex="11" @changed="changed" />
              <span class="ml-1 mr-4">Inactive?</span>
              <input type="checkbox" v-model="receivesReport" class="custom-checkbox" tabindex="12" @changed="changed" />
              <span class="ml-1 mr-4">Receives Reports</span>
              <!-- <input
                type="checkbox"
                v-model="receivesInvoice"
                class="custom-checkbox"
                tabindex="13"
              />
              <span class="ml-1">Receives Invoices</span> -->
            </div>
          </div>
        </div>
        <div class="col-md-12" v-else>
          <!-- <file-upload
            ref="fileUploader"
            v-show="isReadyToUpload"
            :endpoint="endpoint"
            :path="path"
            :folder="folder"
            :userId="userId"
            @finished="finishedUploading"
          />
          <img
            v-show="!isReadyToUpload"
            :src="profilePhoto"
            class="img-responsive img-thumbnail custom-image"
            :alt="defaultPhoto"
          >
          <a
            href="#"
            @click="setReadyToUpload(true)"
            v-show="!isReadyToUpload"
          >upload new photo</a> -->
        </div>
      </div>
      <div class="col-md-7" v-if="!isAdding || (isAdding && isSaved)">
        <dt-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
        <user-record v-if="currentTab === 'Contact Info'" :recordData="user" :showTitles="showTitles" :stacked="stacked" />
        <user-locations v-if="isAdmin && currentTab === 'Locations'" ref="locations" class="custom-locations" @changed="changed" @saved="saved" />
      </div>
      <div class="col-md-7" v-else-if="isVerified">
        <button class="btn btn-primary" @click="save" tabindex="12">Add New User</button>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
import DtTabs from '@/components/utilities/form/dt-tabs'
import UserInfo from '@/components/users/forms/user-info'
import UserRecord from '@/components/users/listings/user-record'
import FileUpload from '@/components/utilities/form/dt-uploader'
import UserLocations from '@/components/users/forms/user-locations'
export default {
  name: 'user-profile',
  components: {
    DtInput,
    DtSelect,
    DtTextarea,
    DtTabs,
    UserInfo,
    UserRecord,
    FileUpload,
    UserLocations
  },
  props: {
    cameFrom: {
      type: Number,
      default: 0
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaved: false,
      saveIt: false,
      showTitles: true,
      stacked: true,
      endpoint: '/file/upload',
      path: '/images/',
      defaultPhoto: null,
      readyToUpload: false,
      newpassword: '',
      isAdding: false,
      isVerified: false,
      newUsername: '',
      editingUsername: false,
      currentTab: 'Contact Info'
    }
  },
  mounted() {
    this.isAdding = this.isAdd
    this.isVerified = !this.isAdd
    this.newUsername = ''
    this.editingUsername = false
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('users', ['user', 'roles']),
    isAdmin() {
      let _is = false
      if (this.profile.roles[0] === 1 || this.profile.roles[0] === 2 || this.profile.roles[0] === 4) {
        _is = true
      }
      return _is
    },
    tabs() {
      let _tabs = ['Contact Info']
      if (this.isAdmin) {
        _tabs.push('Locations')
      }
      return _tabs
    },
    firstName: {
      get() {
        return this.user !== null ? this.user.firstName : ''
      },
      set(value) {
        this.updateUser({
          name: 'firstName',
          value: value
        })
      }
    },
    lastName: {
      get() {
        return this.user !== null ? this.user.lastName : ''
      },
      set(value) {
        this.updateUser({
          name: 'lastName',
          value: value
        })
      }
    },
    timezone: {
      get() {
        return this.user !== null ? this.user.timezone : ''
      },
      set(value) {
        this.updateUser({
          name: 'timezone',
          value: value
        })
      }
    },
    language: {
      get() {
        return this.user !== null ? this.user.language : ''
      },
      set(value) {
        this.updateUser({
          name: 'language',
          value: value
        })
      }
    },
    username: {
      get() {
        return this.user !== null ? this.user.username : ''
      },
      set(value) {
        this.updateUser({
          name: 'username',
          value: value
        })
      }
    },
    password: {
      get() {
        return this.user !== null ? this.user.password : ''
      },
      set(value) {
        this.updateUser({
          name: 'password',
          value: value
        })
      }
    },
    contactType: {
      get() {
        return this.user !== null ? this.user.contactType : 0
      },
      set(value) {
        this.updateUser({
          name: 'contactType',
          value: value
        })
      }
    },
    role: {
      get() {
        let _role = 0
        if (this.user !== null) {
          if (this.user.roles !== null) {
            if (this.user.roles.indexOf(',') > 0) {
              var roles = this.user.roles.split(',')
              _role = roles[0]
            } else {
              _role = this.user.roles
            }
          }
        }
        return _role
      },
      set(value) {
        if (parseInt(value) === 1) {
          value = '2'
        }
        this.updateUser({
          name: 'role',
          value: value
        })
      }
    },
    laborRate: {
      get() {
        return this.user !== null ? this.user.laborRate : ''
      },
      set(value) {
        this.updateUser({
          name: 'laborRate',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        return this.user !== null ? this.user.isInactive : false
      },
      set(value) {
        this.updateUser({
          name: 'isInactive',
          value: value
        })
      }
    },
    receivesReport: {
      get() {
        return this.user !== null ? this.user.receivesReport : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesReport',
          value: value
        })
      }
    },
    receivesInvoice: {
      get() {
        return this.user !== null ? this.user.receivesInvoice : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesInvoice',
          value: value
        })
      }
    },
    email: {
      get() {
        return this.user !== null ? this.user.username : ''
      }
    },
    folder: {
      get() {
        return this.user !== null ? this.user.firm + '/' : ''
      }
    },
    userId: {
      get() {
        return this.user !== null ? this.user.userId : ''
      }
    },
    isReadyToUpload: {
      get() {
        let _showIt = true
        if (this.user !== null) {
          if (this.user.imagePhotoPath !== '') {
            _showIt = false
          }
        }
        if (_showIt === false) {
          if (this.readyToUpload) {
            _showIt = true
          }
        }
        return _showIt
      }
    },
    profilePhoto: {
      get() {
        return this.user !== null ? this.user.imagePhotoPath : ''
      }
    }
  },
  methods: {
    ...mapActions('users', ['getUser', 'saveUser', 'updateUser', 'verifyUsername']),
    setReadyToUpload(value) {
      this.readyToUpload = value
    },
    close() {
      this.$emit('closing')
    },
    showTab(value) {
      this.currentTab = value
    },
    changed() {
      console.log('User data changed')
      this.saveIt = true
      this.$emit('changed')
    },
    saved() {},
    async finishedUploading() {
      await this.getUser(this.user.username)
      this.$refs.fileUploader.reset()
      this.readyToUpload = false
    },
    editUsername() {
      this.newUsername = this.username
      this.editingUsername = true
    },
    saveUsername() {
      this.username = this.newUsername
      this.editingUsername = false
      this.save()
    },
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
        valid = strongRegex.test(this.password)
        if (valid === false) {
          this.reason =
            "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
        }
      }
      return valid
    },
    verifyPassword() {
      if (!this.validatePassword()) {
        alert(this.reason)
      }
    },
    async verifyUser() {
      this.isVerified = false
      let data = await this.verifyUsername(this.user.username)
      if (data.isThere) {
        alert('Username already exists, please try another.')
      } else {
        this.isVerified = true
      }
    },
    async save() {
      let notice = 'Please supply fill all fields.'
      let valid = true
      if (this.user.firstName) {
        if (this.user.firstName.trim() === '') {
          valid = false
          notice += '  Please supply a First Name.'
        }
      } else {
        valid = false
        notice += '  Please supply a First Name.'
      }
      if (this.user.lastName) {
        if (this.user.lastName.trim() === '') {
          valid = false
          notice += '  Please supply a Last Name.'
        }
      } else {
        valid = false
        notice += '  Please supply a First Name.'
      }
      if (this.user.timezone === 0) {
        valid = false
        notice += '  Please supply a Timezone.'
      }
      if (this.user.language === 0) {
        valid = false
        notice += '  Please supply a Language.'
      }
      if (this.user.role === null) {
        valid = false
        notice += '  Please supply a Role.'
      }
      if (valid) {
        this.$emit('saved', this.isSaved)
      } else {
        alert(notice)
      }
      console.log('Saving User Data', this.user)
      if (valid) {
        if (this.$refs.locations) {
          await this.$refs.locations.save()
        }
        await this.saveUser(this.user)
        this.isSaved = true
        this.saveIt = false
        if (this.isAdding) {
          await this.getUser(this.user.username)
        }
        this.$emit('saved', this.isSaved)
        this.isAdding = false
      } else {
        alert(notice)
      }
    }
    // async save() {
    //   let notice = 'Please supply fill all fields.'
    //   // this.$refs.formUser.validate().then(async (success) => {
    //   let valid = true
    //   // if (success) {
    //   if (this.user.firstName) {
    //     if (this.user.firstName.trim() === '') {
    //       valid = false
    //       notice += '  Please supply a First Name.'
    //     }
    //   } else {
    //     valid = false
    //     notice += '  Please supply a First Name.'
    //   }
    //   if (this.user.lastName) {
    //     if (this.user.lastName.trim() === '') {
    //       valid = false
    //       notice += '  Please supply a Last Name.'
    //     }
    //   } else {
    //     valid = false
    //     notice += '  Please supply a First Name.'
    //   }
    //   if (this.user.timezone === 0) {
    //     valid = false
    //     notice += '  Please supply a Timezone.'
    //   }
    //   if (this.user.language === 0) {
    //     valid = false
    //     notice += '  Please supply a Language.'
    //   }
    //   if (this.user.role === null) {
    //     valid = false
    //     notice += '  Please supply a Role.'
    //   }
    //   console.log('Saving the User Profile', this.user)
    //   if (valid) {
    //     await this.$refs.locations.save()
    //     await this.saveUser(this.user)
    //     this.isSaved = true
    //     this.saveIt = false
    //     if (this.isAdding) {
    //       console.log('Refreshing User after Adding')
    //       await this.getUser(this.user.username)
    //     }
    //     this.$emit('saved', this.isSaved)
    //     this.isAdding = false
    //   } else {
    //     alert(notice)
    //   }
    //   // } else {
    //   //   alert(notice)
    //   // }
    //   // })
    // }
  }
}
</script>
<style lang="scss" scoped>
.custom-image {
  width: 300px;
  height: 300px;
}
.custom-username {
  position: relative;
  a {
    float: right;
    color: #2c6ffe;
  }
}
.custom-locations {
  height: 450px;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-profile.vue